import route from './route';
import { LazyloadWrapper } from '../../Components/Common';

const GroupManagement = LazyloadWrapper(import('./GroupManagement'));

export default {
  RenderProp: GroupManagement,
  mainRoute: route,
};
